/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react'
import styles from './style.module.scss'
import { Col, Row } from 'react-bootstrap'
import useWindowSize from '@shared/hooks/windowSize'
import CustomLink from '@shared/components/customLink'
import india from '@assets/images/championTrophy/teamFlags/india.png'
import pakistan from '@assets/images/championTrophy/teamFlags/pakistan.png'
import westIndies from '@assets/images/championTrophy/teamFlags/westIndies.svg'
import australia from '@assets/images/championTrophy/teamFlags/australia.png'
import newZealand from '@assets/images/championTrophy/teamFlags/newZealand.png'
import southAfrica from '@assets/images/championTrophy/teamFlags/southAfrica.png'
import Image from 'next/future/image'
import MyImage from '@shared/components/myImage'
import { getImgURL } from '@shared-submodule/utils'
// import GoogleAds from '@shared-submodule/sm-components/googleAds'
// import { googleAddData } from '@shared-submodule/sm-constants/googleAdsData'
import dynamic from 'next/dynamic'
import { reviveAdData } from '@shared/components/reviveAds/reviveAdData'

const ReviveAds = dynamic(() => import('@shared/components/reviveAds'), { ssr: false })

const WPLTimeline = ({ data, teamData, team }) => {
  const [filter, setFilter] = useState('Group A')
  const [width] = useWindowSize()
  const { addTop } = reviveAdData

  return (
    <div className={styles.container}>

      {width > 767 && (
        <>
          <div className="p-4">
            <div className="w-full d-none d-xl-flex justify-content-center ">
              {/* <GoogleAds
                addId={googleAddData?.addTop?.addId}
                divId={'div-gpt-ad-1726652607873-0'}
                dimension={googleAddData?.addTop?.dimension}
                slotId={googleAddData?.addTop?.slotId}
                className={'mb-4'}
              /> */}
              <ReviveAds {...addTop} className={'mb-4'}/>
            </div>
            <div className="d-flex justify-content-between align-items-center w-100">
              <h2 className={`${styles.title} mt-0`}>Teams</h2>
            </div>
            <div>
              <Row>
                {team?.map((a, i) => {
                  return (
                    <Col key={i} className="d-flex justify-content-center">
                      <Col>
                        <CustomLink href={a?.oSeo?.sSlug}>
                          <a>
                            <div className={`${styles.teamContainer} cursor-pointer`}>
                              <MyImage src={getImgURL(a?.oImg?.sUrl)} height={150} width={150} />
                            </div>
                            <h6 className={`${styles.teamName} cursor-pointer`}>{a?.sTitle || ''}</h6>
                          </a>
                        </CustomLink>
                      </Col>
                    </Col>
                  )
                })}
              </Row>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default WPLTimeline
